var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2725_1223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 19.2853C15.1283 19.2853 19.2857 15.1279 19.2857 9.99958C19.2857 4.87122 15.1283 0.713867 9.99995 0.713867C4.87159 0.713867 0.714233 4.87122 0.714233 9.99958C0.714233 15.1279 4.87159 19.2853 9.99995 19.2853Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.2857H19.5714M13.8571 10.2857C13.6817 13.6814 12.431 16.9334 10.2857 19.5714C8.14046 16.9334 6.88971 13.6814 6.71429 10.2857C6.88971 6.89001 8.14046 3.63807 10.2857 1C12.431 3.63807 13.6817 6.89001 13.8571 10.2857Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2725_1223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.bb87e60bce61f4cd79e15f866d7fe4b6.svg";
export { ForwardRef as ReactComponent };